const fmtDecimal = (n) =>
    Math.abs(n).toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

const sign = (n) => (n > 0 ? "+" : n < 0 ? "−" : "");

/** 1934 => "1 934" */
export const fmtNumber = (n) => (n ?? 0).toLocaleString("fr-FR");

/** -3.25 => "−3,25" */
export const fmtSignedHoursValue = (n = 0) => sign(n) + fmtDecimal(n);

/** -3.25 => "−3,25 h" */
export const fmtSignedHours = (n = 0) => `${fmtSignedHoursValue(n)} h`;

/** les parts arrivent en valeur absolue, le signe est celui de recovery_hours */
export const fmtRecoveryDetail = ({
    recovery_hours = 0,
    recovery_days_part = 0,
    recovery_hours_part = 0,
}) =>
    `soit ${recovery_hours < 0 ? "−" : ""}${fmtNumber(
        recovery_days_part
    )} j et ${fmtDecimal(recovery_hours_part)} h`;

export const getRecoveryColor = (n) =>
    n < 0 ? "#C4314B" : n > 0 ? "#107C41" : "#424242";

export const getInitials = (first_name = "", last_name = "") =>
    `${first_name?.[0] ?? ""}${last_name?.[0] ?? ""}`.toUpperCase();

export const pluralize = (count, singular, plural = `${singular}s`) =>
    `${count} ${count > 1 ? plural : singular}`;
